export type GalleryCategory = 'All' | 'Weddings' | 'Festivals' | 'Corporate & Private Events' | 'Bespoke Decor' | 'Markets & Outdoor' | 'Custom Skins';

export interface GalleryImage {
  id: number;
  category: Exclude<GalleryCategory, 'All'>;
  src: string;
  alt: string;
  title: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    category: 'Weddings',
    src: '/assets/img/b3fdc32a2821.webp',
    alt: 'Elegant wedding reception under white stretch tent',
    title: 'Countryside Wedding Reception',
  },
  {
    id: 3,
    category: 'Weddings',
    src: '/assets/img/2fa2a3c2c495.webp',
    alt: 'Wedding dance floor under lit stretch tent',
    title: 'Evening Wedding Celebrations',
  },
  {
    id: 6,
    category: 'Festivals',
    src: '/assets/img/1c528fbbf9ed.webp',
    alt: 'Festival stage under stretch tent at night',
    title: 'Festival Night Stage',
  },
  {
    id: 7,
    category: 'Festivals',
    src: '/assets/img/4d3f2cabb8c4.webp',
    alt: 'Outdoor culture festival with stretch tents',
    title: 'Culture & Food Festival',
  },
  {
    id: 27,
    category: 'Festivals',
    src: '/assets/img/8098d0119ecb.webp',
    alt: 'Aerial view of music festival with stretch tents',
    title: 'Festival Grounds Overview',
  },
  {
    id: 29,
    category: 'Festivals',
    src: '/assets/img/cada58805478.webp',
    alt: 'Family summer festival under stretch tent',
    title: 'Family Summer Fête',
  },
  {
    id: 30,
    category: 'Festivals',
    src: '/assets/img/5e44cf75df93.webp',
    alt: 'Jazz festival under stretch tent in the evening',
    title: 'Jazz & Blues Evening',
  },
  {
    id: 31,
    category: 'Festivals',
    src: '/assets/img/54b34de603e5.webp',
    alt: 'Outdoor film festival under stretch tent',
    title: 'Open-Air Cinema Festival',
  },
  {
    id: 32,
    category: 'Festivals',
    src: '/assets/img/e44756b7df8c.webp',
    alt: 'Street food festival under stretch tents',
    title: 'World Street Food Fest',
  },
  {
    id: 33,
    category: 'Festivals',
    src: '/assets/img/302bcae24319.webp',
    alt: 'Folk music festival in woodland under stretch tent',
    title: 'Woodland Folk Festival',
  },
  {
    id: 34,
    category: 'Festivals',
    src: '/assets/img/66afab4318cb.webp',
    alt: 'Wellness yoga festival under stretch tent',
    title: 'Wellness & Yoga Festival',
  },
  {
    id: 35,
    category: 'Festivals',
    src: '/assets/img/b4c9dafdddb2.webp',
    alt: 'Beer and cider festival under stretch tents',
    title: 'Craft Beer Festival',
  },
  {
    id: 36,
    category: 'Festivals',
    src: '/assets/img/36dafc6609e9.webp',
    alt: 'Autumn harvest festival under stretch tent',
    title: 'Harvest Autumn Festival',
  },
  {
    id: 37,
    category: 'Festivals',
    src: '/assets/img/ac8257ff000e.webp',
    alt: 'Cultural heritage festival under stretch tent',
    title: 'Heritage & Culture Day',
  },
  {
    id: 9,
    category: 'Corporate & Private Events',
    src: '/assets/img/569783cbf383.webp',
    alt: 'Corporate networking event under stretch tent',
    title: 'Annual Corporate Summit',
  },
  {
    id: 10,
    category: 'Corporate & Private Events',
    src: '/assets/img/37712d4f02cf.webp',
    alt: 'Product launch under stretch tent',
    title: 'Tech Product Launch',
  },
  {
    id: 11,
    category: 'Corporate & Private Events',
    src: '/assets/img/126d7a3e4add.webp',
    alt: 'Business conference under stretch tent',
    title: 'Leadership Conference',
  },
  {
    id: 39,
    category: 'Corporate & Private Events',
    src: '/assets/img/172e30b82ebb.webp',
    alt: 'Corporate awards ceremony under stretch tent',
    title: 'Annual Awards Ceremony',
  },
  {
    id: 40,
    category: 'Corporate & Private Events',
    src: '/assets/img/efe86619396d.webp',
    alt: 'Brand activation event under stretch tent',
    title: 'Brand Activation Day',
  },
  {
    id: 42,
    category: 'Corporate & Private Events',
    src: '/assets/img/71e05d7dea36.webp',
    alt: 'Team building event under stretch tent',
    title: 'Team Building Day Out',
  },
  {
    id: 44,
    category: 'Corporate & Private Events',
    src: '/assets/img/2f19edb35d01.webp',
    alt: 'Charity gala fundraiser under stretch tent',
    title: 'Charity Gala Fundraiser',
  },
  {
    id: 45,
    category: 'Corporate & Private Events',
    src: '/assets/img/4bf960680d38.webp',
    alt: 'Corporate summer party under stretch tent',
    title: 'Company Summer Party',
  },
  {
    id: 46,
    category: 'Corporate & Private Events',
    src: '/assets/img/5b68e8526c0c.webp',
    alt: 'Private birthday celebration under stretch tent',
    title: 'Private Birthday Celebration',
  },
  {
    id: 13,
    category: 'Bespoke Decor',
    src: '/assets/img/76f1f6924aa1.webp',
    alt: 'Birthday party under decorated stretch tent',
    title: 'Milestone Birthday Bash',
  },
  {
    id: 16,
    category: 'Bespoke Decor',
    src: '/assets/img/8c08ca7fbc83.webp',
    alt: 'Graduation celebration under stretch tent',
    title: 'Graduation Celebration',
  },
  {
    id: 73,
    category: 'Bespoke Decor',
    src: '/assets/img/a874f2e12a5b.webp',
    alt: 'Bespoke floral ceiling installation under stretch tent',
    title: 'Cascading Floral Ceiling',
  },
  {
    id: 74,
    category: 'Bespoke Decor',
    src: '/assets/img/a391e6deefcd.webp',
    alt: 'Draped fabric and chandelier bespoke tent decor',
    title: 'Ivory & Gold Drape Setup',
  },
  {
    id: 76,
    category: 'Bespoke Decor',
    src: '/assets/img/875051dbe36d.webp',
    alt: 'Bohemian macrame bespoke tent decor',
    title: 'Boho Macrame Styling',
  },
  {
    id: 79,
    category: 'Bespoke Decor',
    src: '/assets/img/9aff94783e59.webp',
    alt: 'Art deco gatsby themed bespoke tent decor',
    title: 'Art Deco Gatsby Night',
  },
  {
    id: 80,
    category: 'Bespoke Decor',
    src: '/assets/img/3d6a1c9f2f89.webp',
    alt: 'Rustic barn style bespoke tent decor',
    title: 'Rustic Barn Styling',
  },
  {
    id: 81,
    category: 'Bespoke Decor',
    src: '/assets/img/b8e72fcab005.webp',
    alt: 'Mediterranean themed bespoke tent decor',
    title: 'Mediterranean Summer Feast',
  },

  {
    id: 17,
    category: 'Markets & Outdoor',
    src: '/assets/img/651bc6ed489f.webp',
    alt: 'Artisan market under stretch tent',
    title: 'Artisan Craft Market',
  },
  {
    id: 18,
    category: 'Markets & Outdoor',
    src: '/assets/img/ffc8695ca2df.webp',
    alt: 'Farmers market under stretch tent',
    title: "Weekend Farmers' Market",
  },
  {
    id: 19,
    category: 'Markets & Outdoor',
    src: '/assets/img/a09813075774.webp',
    alt: 'Outdoor food market under stretch tent',
    title: 'Gourmet Food Market',
  },
  {
    id: 20,
    category: 'Markets & Outdoor',
    src: '/assets/img/0b5d4af6a09c.webp',
    alt: 'Winter Christmas market under stretch tent',
    title: 'Winter Christmas Market',
  },
  {
    id: 47,
    category: 'Markets & Outdoor',
    src: '/assets/img/3c8536d20984.webp',
    alt: 'Antique flea market under stretch tent',
    title: 'Vintage Flea Market',
  },
  {
    id: 48,
    category: 'Markets & Outdoor',
    src: '/assets/img/eb1690d7e46a.webp',
    alt: 'Street food market under stretch tent',
    title: 'Street Food Night Market',
  },
  {
    id: 49,
    category: 'Markets & Outdoor',
    src: '/assets/img/252c345ecd61.webp',
    alt: 'Plant and flower market under stretch tent',
    title: 'Garden Plant Market',
  },
  {
    id: 50,
    category: 'Markets & Outdoor',
    src: '/assets/img/ff3e677e6f0a.webp',
    alt: 'Outdoor book fair under stretch tent',
    title: 'Open-Air Book Fair',
  },
  {
    id: 51,
    category: 'Markets & Outdoor',
    src: '/assets/img/a4bf0bd7657a.webp',
    alt: 'Organic wellness market under stretch tent',
    title: 'Organic Wellness Market',
  },
  {
    id: 52,
    category: 'Markets & Outdoor',
    src: '/assets/img/713e192e6ee5.webp',
    alt: 'Jewellery market under stretch tent',
    title: 'Handmade Jewellery Market',
  },
  {
    id: 53,
    category: 'Markets & Outdoor',
    src: '/assets/img/7a0cc5573cfe.webp',
    alt: 'Children toy market under stretch tent',
    title: "Children's Toy Market",
  },
  {
    id: 54,
    category: 'Markets & Outdoor',
    src: '/assets/img/482fffeb0595.webp',
    alt: 'Artisan cheese and deli market under stretch tent',
    title: 'Artisan Cheese & Deli',
  },
  {
    id: 55,
    category: 'Markets & Outdoor',
    src: '/assets/img/38cb680e7a82.webp',
    alt: 'Vintage clothing market under stretch tent',
    title: 'Vintage Fashion Market',
  },
  {
    id: 56,
    category: 'Markets & Outdoor',
    src: '/assets/img/c3f55ca5f5fb.webp',
    alt: 'Beer and wine tasting market under stretch tent',
    title: 'Craft Beer & Wine Tasting',
  },
  {
    id: 57,
    category: 'Markets & Outdoor',
    src: '/assets/img/2bf586601d94.webp',
    alt: 'Art and photography market under stretch tent',
    title: 'Art & Photography Fair',
  },

  {
    id: 59,
    category: 'Custom Skins',
    src: '/assets/img/c54a6a6dfa4c.webp',
    alt: 'Stretch tent with a custom-printed brand logo skin',
    title: 'Brand Logo Skin',
  },
  {
    id: 60,
    category: 'Custom Skins',
    src: '/assets/img/9b3aedd4c5c0.webp',
    alt: 'Stretch tent with a custom-printed geometric skin',
    title: 'Geometric Pattern Canopy',
  },
  {
    id: 61,
    category: 'Custom Skins',
    src: '/assets/img/f15012e9c6bd.webp',
    alt: 'Stretch tent with a custom-printed tropical floral skin',
    title: 'Tropical Floral Skin',
  },
  {
    id: 62,
    category: 'Custom Skins',
    src: '/assets/img/fb37793dec38.webp',
    alt: 'Stretch tent with a corporate branded custom skin',
    title: 'Corporate Exhibition Tent',
  },
  {
    id: 64,
    category: 'Custom Skins',
    src: '/assets/img/ee778e36b0aa.webp',
    alt: 'Stretch tent with a sports branded custom skin',
    title: 'Sports Team Branded Tent',
  },
  {
    id: 65,
    category: 'Custom Skins',
    src: '/assets/img/acebfce8e6c9.webp',
    alt: 'Stretch tent with a custom-printed landscape photography skin',
    title: 'Landscape Photo Skin',
  },
  {
    id: 66,
    category: 'Custom Skins',
    src: '/assets/img/ad0b63be293b.webp',
    alt: 'Stretch tent with a Christmas themed custom skin',
    title: 'Festive Christmas Skin',
  },
  {
    id: 67,
    category: 'Custom Skins',
    src: '/assets/img/9ec458b542cf.webp',
    alt: 'Stretch tent with a luxury black and gold custom skin',
    title: 'Luxury Brand Skin',
  },
  {
    id: 68,
    category: 'Custom Skins',
    src: '/assets/img/fd91180b0bef.webp',
    alt: 'Stretch tent with a custom-printed music festival artwork skin',
    title: 'Festival Artwork Canopy',
  },

  {
    id: 22,
    category: 'Weddings',
    src: '/assets/img/e05744b5387d.webp',
    alt: 'Wedding cocktail hour under draped stretch tent',
    title: 'Cocktail Hour in the Garden',
  },
  {
    id: 24,
    category: 'Weddings',
    src: '/assets/img/a18aade5babf.webp',
    alt: 'Boho wedding reception under ivory stretch tent',
    title: 'Boho Chic Celebration',
  },
  {
    id: 25,
    category: 'Weddings',
    src: '/assets/img/95409d39e49a.webp',
    alt: 'Wedding sweetheart table under floral arch and stretch tent',
    title: 'Sweetheart Table Setup',
  },
  {
    id: 26,
    category: 'Weddings',
    src: '/assets/img/50f00461fa3b.webp',
    alt: 'Evening wedding feast under stretch tent in woodland setting',
    title: 'Woodland Evening Feast',
  },
];

const findById = (id: number) => galleryImages.find((img) => img.id === id)!;

export const featuredImages: Record<GalleryCategory, GalleryImage> = {
  All: findById(1),
  Weddings: findById(1),
  Festivals: findById(6),
  'Corporate & Private Events': findById(9),
  'Bespoke Decor': findById(13),
  'Markets & Outdoor': findById(17),
  'Custom Skins': findById(59),
};
